/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceCategoryListEntry } from './NotificationPreferenceCategoryListEntry';
import {
    NotificationPreferenceCategoryListEntryFromJSON,
    NotificationPreferenceCategoryListEntryFromJSONTyped,
    NotificationPreferenceCategoryListEntryToJSON,
    NotificationPreferenceCategoryListEntryToJSONTyped,
} from './NotificationPreferenceCategoryListEntry';

/**
 * 
 * @export
 * @interface FindAllPreferences200Response
 */
export interface FindAllPreferences200Response {
    /**
     * 
     */
    data?: Array<NotificationPreferenceCategoryListEntry>;
}

/**
 * Check if a given object implements the FindAllPreferences200Response interface.
 */
export function instanceOfFindAllPreferences200Response(value: object): value is FindAllPreferences200Response {
    return true;
}

export function FindAllPreferences200ResponseFromJSON(json: any): FindAllPreferences200Response {
    return FindAllPreferences200ResponseFromJSONTyped(json, false);
}

export function FindAllPreferences200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPreferences200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(NotificationPreferenceCategoryListEntryFromJSON)),
    };
}

export function FindAllPreferences200ResponseToJSON(json: any): FindAllPreferences200Response {
    return FindAllPreferences200ResponseToJSONTyped(json, false);
}

export function FindAllPreferences200ResponseToJSONTyped(value?: FindAllPreferences200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(NotificationPreferenceCategoryListEntryToJSON)),
    };
}

